import React from 'react';
import PropTypes from 'prop-types';
import './style.css';

const ProgressBar = ({ percentage }) => {
  const greenWidth = `${percentage}%`;
  const redWidth = `${100 - percentage}%`;

  return (
    <div className="progress-bar">
      <div className="progress-green" style={{ width: greenWidth }} />
      <div className="progress-red" style={{ width: redWidth }} />
      <div className="progress-text">
        {percentage}
        %
      </div>
    </div>
  );
};

ProgressBar.propTypes = {
  percentage: PropTypes.number.isRequired,
};

export default ProgressBar;
